
























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

@Component
export default class DatePickerComponent extends Vue {
  @Prop() value?: string | null;
  @Prop() label?: string;
  @Prop() clearable?: boolean;
  @Prop({default:false}) disable?: boolean;
  current?: string | null = null;
  isMenuOpen: boolean = false;

  created() {
    if (this.value) this.current = this.value.substring(0, 10);
  }

  @Watch("current")
  onChange() {
    this.$emit(
      "input",
      new Date(this.current || "").toISOString().split(".")[0]
    );
  }

  onClear() {
    this.$emit("input", null);
  }

  get formatedDate(): string {
    return this.current
      ? moment(this.current).format(process.env.VUE_APP_CONFIGS_DATE_FORMAT)
      : "";
  }
}
